import { DiscountReportComponent } from './discount.report/discount.report.component';
import { CreditReportComponent } from './credit.report/credit.report.component';
import { MonitoringRoutingModule } from './monitoring.routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedAppModule } from '../app.module.shared';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SweetAlertService } from 'ng2-cli-sweetalert2'

// COMPONENTS
import { TOSReportComponent } from './tos.report/tos.report.component';
import { GracePeriodReportComponent } from './grace.period.report/grace.period.report.component';
import { BillingReportComponent } from './billing.report/billing.report.component';
import { InvoiceReportComponent } from './invoice.report/invoice.report.component';
import { AutomatedBillingReportComponent } from './automated.billing.report/automated.billing.report.component';
import { AbandonedCartComponent } from './abandoned.cart.report/abandoned.cart.report.component';

import { HoldReportComponent } from './hold.report/hold.report.component';
import { TOSMACWhitelistComponent } from './tos-mac-whitelist/tos.mac.whitelist.component';
import { TOSPhoneWhitelistComponent } from './tos-phone-whitelist/tos.phone.whitelist.component';
import { TOSAddressWhitelistComponent } from './tos-address-whitelist/tos.address.whitelist.component';

@NgModule({
    declarations: [
        TOSReportComponent,
        GracePeriodReportComponent,
        BillingReportComponent,
        InvoiceReportComponent,
        CreditReportComponent,
        DiscountReportComponent,
        AutomatedBillingReportComponent,
		AbandonedCartComponent,
		HoldReportComponent,
        TOSMACWhitelistComponent,
        TOSPhoneWhitelistComponent,
        TOSAddressWhitelistComponent
    ],
    imports: [
        CommonModule,
        SharedAppModule,
        ReactiveFormsModule,
        FormsModule,
        MonitoringRoutingModule
    ],
    entryComponents: [

    ],
    providers: [
        SweetAlertService
    ]
})

export class MonitoringModule { }
